import * as React from "react";
import { Autocomplete, Button, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { FilterDef, FilterOption } from "./filterDefs";
import { FilterValues } from "./useRowFilter";
import "./TableFilters.css";

// Barra de filtros común de las tablas: rejilla de hasta 4 campos con el mismo
// formato que los del formulario de añadir/editar (TextField y Autocomplete
// "outlined" con el estilo del tema). Se filtra al momento, sin botón "Buscar".

export type { FilterValues };

type TableFiltersProps = {
  search: string;
  onSearchChange: (value: string) => void;
  filters: FilterDef[];
  values: FilterValues;
  onFilterChange: (id: string, value: FilterOption | null) => void;
  onClear: () => void;
  resultCount: number;
  totalCount: number;
};

const MAX_COLUMNS = 4;

export default function TableFilters(props: TableFiltersProps) {
  const { search, onSearchChange, filters, values, onFilterChange, onClear, resultCount, totalCount } = props;
  const isFiltered = search.trim() !== "" || Object.values(values).some((v) => v !== null);
  const columns = Math.min(filters.length + 1, MAX_COLUMNS);

  return (
    <div className="tableFilters">
      <div className="tableFilters__fields" style={{ "--filter-columns": columns } as React.CSSProperties}>
        <TextField
          id="table-search"
          className="tableFilters__field"
          label="Buscar"
          placeholder="Escriba para buscar…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        {filters.map((filter) => (
          <Autocomplete
            key={filter.id}
            id={`table-filter-${filter.id}`}
            className="tableFilters__field"
            options={filter.options}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            value={values[filter.id] ?? null}
            onChange={(_e, value) => onFilterChange(filter.id, value)}
            noOptionsText="Sin opciones"
            renderInput={(params) => <TextField {...params} label={filter.label} />}
          />
        ))}
      </div>
    </div>
  );
}
